import { debounce } from "../../../helpers";

export default () => {
  const body = document.querySelector("body");
  const delay = 250;
  let scrollTopBtn = document.createElement("button");

  const func = () => {
    if (window.scrollY == 0) {
      scrollTopBtn.classList.add("hide");
    } else {
      scrollTopBtn.classList.remove("hide");
    }
  };

  if (body !== null) {
    scrollTopBtn.innerHTML = `<span>Back to top</span>`;
    scrollTopBtn.classList.add("btn--scroll-top", "hide");
    scrollTopBtn.addEventListener("click", () => {
      window.scrollTo(0, 0);
    });
    body.appendChild(scrollTopBtn);
  }

  func();
  debounce({ func, delay, event: "scroll" });
};
